import axios from '../axiosCall'
import Urls from "../endpoints";

export const getProvince = () => {
    return axios.get(Urls.getProvinceWithCity())
}


export const setUserNotesAutomatic = (userId, note, type) => {
    return axios.post(Urls.setUserNotes(userId), { "NoteType": type,"note":note })
}

export const getAllNote = (id) => {
    return axios.get(Urls.getUserNotes(id))
}


export const saveByAdmin = (objModel) => {
    return axios.post(Urls.saveByAdmin(), objModel)
}
export const getCustomerEmailHistory = (objModel) => {
    return axios.post(Urls.getCustomerEmailHistory(), objModel)
}
export const getSearchedUserById = (id) => {
    return axios.get(Urls.getSearchedUserById(id))
}

export const unlockMobile = (id) => {
    return axios.post(Urls.unLockeMobile(id))
}

export const unlockEmail = (id) => {
    return axios.get(Urls.unLockeEmail(id))
}



